<template>
  <b-col>
    <b-row class="title"> Nos solutions pour les {{ name }} : </b-row>
    <b-row class="subtitle mt-3">
      Myfo développe actuellement des outils intelligents d'aide à la prise de décision pour mieux conseiller les particuliers dans la gestion de leur épargne.
    </b-row>
    <b-row class="mt-5">
      <div class="content">Nous développons entre autres :</div>
    </b-row>
    <b-row>
      <div class="content">
        <ul>
          <li>
            Un optimiseur personnalisé de frais (de plateformes et de fonds)
          </li>
          <li>
            Une alternative personnalisée de portefeuille avec des positions ESG
          </li>
          <li>
            Une gestion du risque personnalisée en fonction des objectifs de l'épargnant et des fluctuations du marché
          </li>
          <li>Une analyse des biais comportementaux des épargnants</li>
          <li>
            Une market place d'asset manager pour répliquer et personnaliser leurs recommandations
          </li>
          <li>Et bien d'autres...</li>
        </ul>
      </div>
    </b-row>
    <b-row class="mt-4">
      <img src="../comps/MockupConseil.png" style="width: 100%" alt="Mockup-conseil" />
    </b-row>
    <b-row class="mt-5">
      <b-button>Nous contacter</b-button>
    </b-row>
  </b-col>
</template>
<script>
export default {
  props: ["name"],
};
</script>
<style lang="scss">
@import "../../../../../sass/_variables.scss";
#offrePro {
  .title {
    text-align: left;
    font: normal normal bold $mf_ft_size_big_title Dosis;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
  }

  .subtitle {
    text-align: left;
    font: normal normal bold $mf_ft_size_big_subtitle Segoe UI;
    letter-spacing: 0px;
    color: #707070;
    opacity: 1;
  }

  .content {
    text-align: left;
    font: normal normal normal $mf_ft_size_text Segoe UI;
    letter-spacing: 0px;
    color: #707070;
    opacity: 1;
  }
  li {
    text-align: left;
    margin: 10px;

    &::marker {
      color: $blue_color;
      font-size: 25px;
    }
  }
  button {
    background: $blue_color 0% 0% no-repeat padding-box;
    box-shadow: 0px 3px 6px #00000029;
    border-radius: 62px;
    opacity: 1;
    width: 300px;
    border: none;
    margin: auto;
  }
}
</style>
